import React from 'react';
import { CheckmarkCircle12Filled, Warning12Filled } from '@fluentui/react-icons';
import { MODULE_CATEGORY_ORDER } from './overviewDummyData';
import styles from '../intelligenceInsights.module.css';

const OVERVIEW_KEY = 'overview';

const StatusIcon = ({ status }) => {
    if (status === 'warnings') {
        return <Warning12Filled className={styles.navStatusWarning} aria-hidden />;
    }
    if (status === 'complete' || status === 'new_evidence') {
        return <CheckmarkCircle12Filled className={styles.navStatusComplete} aria-hidden />;
    }
    return null;
};

/**
 * Figma Insights sidebar: Overview + categorized modules with status icons.
 */
const IntelligenceInsightsNav = ({
    modules = [],
    selectedKey = OVERVIEW_KEY,
    onSelect,
    moduleCount = 8,
}) => {
    return (
        <nav className={styles.insightsNav} aria-label="Intelligence insight sections">
            <div className={styles.insightsNavHeader}>
                <p className={styles.insightsNavHeaderTitle}>Intelligence Insights</p>
                <p className={styles.insightsNavHeaderMeta}>{moduleCount} modules</p>
            </div>

            <div className={styles.insightsNavScroll}>
                <button
                    type="button"
                    className={`${styles.insightsNavOverview} ${
                        selectedKey === OVERVIEW_KEY ? styles.insightsNavOverviewActive : ''
                    }`}
                    onClick={() => onSelect(OVERVIEW_KEY)}
                    aria-current={selectedKey === OVERVIEW_KEY ? 'true' : undefined}>
                    Overview
                </button>

                <div className={styles.insightsNavDivider} aria-hidden />

                {MODULE_CATEGORY_ORDER.map((section, index) => {
                    const items = modules.filter(m => m.category === section.key);
                    if (!items.length) return null;
                    return (
                        <div key={section.key} className={styles.insightsNavSection}>
                            {index > 0 ? (
                                <div className={styles.insightsNavDivider} aria-hidden />
                            ) : null}
                            <p className={styles.insightsNavSectionLabel}>{section.label}</p>
                            <ul className={styles.insightsNavList}>
                                {items.map(item => {
                                    const isActive = item.key === selectedKey;
                                    return (
                                        <li key={item.key}>
                                            <button
                                                type="button"
                                                className={`${styles.insightsNavItem} ${
                                                    isActive ? styles.insightsNavItemActive : ''
                                                }`}
                                                onClick={() => onSelect(item.key)}
                                                aria-current={isActive ? 'true' : undefined}>
                                                <span className={styles.insightsNavItemTitle}>
                                                    {item.title}
                                                </span>
                                                <StatusIcon status={item.status} />
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </nav>
    );
};

export default IntelligenceInsightsNav;
export { OVERVIEW_KEY };
